import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

export default function KH1000100003() {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <>
        <p>
          1. Mr. Chhay Soeun
          <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".b" position="right" event="both">
            Chairman
          </Tooltip>
        </p>
        <p>
          2. Dr. In Channy
          <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
            (c)
          </span>
          <Tooltip target=".c" position="right" event="both">
            Executive Director
          </Tooltip>
        </p>
        <p>
          3. Mr. Rath Yumeng
          <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
            (d)
          </span>
          <Tooltip target=".d" position="right" event="both">
            Executive Director
          </Tooltip>
        </p>
        <p>
          4. Mr. Stéphane MANGIAVACCA
          <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
            (e)
          </span>
          <Tooltip target=".e" position="right" event="both">
            Non-executive Director
          </Tooltip>
        </p>
        <p>
          5. Mr. Kyosuke Hattori
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (f)
          </span>
          <Tooltip target=".f" position="right" event="both">
            Non-executive Director
          </Tooltip>
        </p>
        <p>
          6. Dr. Albertus Bruggink
          <span className="vertical-align-super g text-xs text-yellow-500 pl-1">
            (g)
          </span>
          <Tooltip target=".g" position="right" event="both">
            Non-executive Director
          </Tooltip>
        </p>
        <p>
          7. Mr. Kay Lot
          <span className="vertical-align-super h text-xs text-yellow-500 pl-1">
            (h)
          </span>
          <Tooltip target=".h" position="right" event="both">
            Non-executive Director
          </Tooltip>
        </p>
        <p>
          8. Drs. Pieter Kooi
          <span className="vertical-align-super i text-xs text-yellow-500 pl-1">
            (i)
          </span>
          <Tooltip target=".i" position="right" event="both">
            Independent Director
          </Tooltip>
        </p>
        <p>
          9. Mr. Van Sou leng
          <span className="vertical-align-super j text-xs text-yellow-500 pl-1">
            (j)
          </span>
          <Tooltip target=".j" position="right" event="both">
            Independent Director
          </Tooltip>
        </p>
        <p>
          10. Ms. Phurik Ratana
          <span className="vertical-align-super k text-xs text-yellow-500 pl-1">
            (k)
          </span>
          <Tooltip target=".k" position="right" event="both">
            Independent Director
          </Tooltip>
        </p>
      </>
    );
  }
  return (
    <>
      <p>
        ១. លោក ឆាយ សឿន
        <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".b" position="right" event="both">
          ប្រធានក្រុមប្រឹក្សាភិបាល
        </Tooltip>
      </p>
      <p>
        ២. បណ្ឌិត អ៊ិន ចាន់នី
        <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
          (c)
        </span>
        <Tooltip target=".c" position="right" event="both">
          អភិបាលប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៣. លោក រ័ត្ន យូម៉េង
        <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
          (d)
        </span>
        <Tooltip target=".d" position="right" event="both">
          អភិបាលប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៤. លោក Stéphane MANGIAVACCA
        <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
          (e)
        </span>
        <Tooltip target=".e" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៥. លោក Kyosuke Hattori
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (f)
        </span>
        <Tooltip target=".f" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៦. លោក Albertus Bruggink
        <span className="vertical-align-super g text-xs text-yellow-500 pl-1">
          (g)
        </span>
        <Tooltip target=".g" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៧. លោក Kay Lot
        <span className="vertical-align-super h text-xs text-yellow-500 pl-1">
          (h)
        </span>
        <Tooltip target=".h" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៨. បណ្ឌិត Pieter Kooi
        <span className="vertical-align-super i text-xs text-yellow-500 pl-1">
          (i)
        </span>
        <Tooltip target=".i" position="right" event="both">
          អភិបាលឯករាជ្យ
        </Tooltip>
      </p>
      <p>
        ៩. លោក វ៉ាន់ ស៊ូអៀង
        <span className="vertical-align-super j text-xs text-yellow-500 pl-1">
          (j)
        </span>
        <Tooltip target=".j" position="right" event="both">
          អភិបាលឯករាជ្យ
        </Tooltip>
      </p>
      <p>
        ១០. លោកស្រី Phurik Ratana
        <span className="vertical-align-super k text-xs text-yellow-500 pl-1">
          (k)
        </span>
        <Tooltip target=".k" position="right" event="both">
          អភិបាលឯករាជ្យ
        </Tooltip>
      </p>
    </>
  );
}
